module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "walnut-dune-timber-kimberly-1.fa9b7e8c.jpg";